module.exports = __webpack_public_path__ + "img/LevelNext_homeofcollegiateesports white.0310c71d.png";